export const MAP_SOURCE_NAME = 'map_source';
export const SEPARATED_SOURCE_NAME = 'map_source_seperated';
export const SELECTED_FEATURE_PROPERTY = 'SELECTED_FEATURE_PROPERTY';
export const CLUSTERED_SELECTED_FEATURE_PROPERTY = 'CLUSTERED_SELECTED_FEATURE_PROPERTY';
export const CIRCLE_OPACITY = 1;
